/** @format */

import React from 'react';
import { Card } from 'antd';

export default function CustomCard(props) {
	return <Card {...props} />;
}
